import axios from "axios";
import { CardDTO } from "./CardDataType";

type CardDataMinimized = {
  name: string;
  slug: string;
  type: "site" | ("minion" & string);
};
export async function getCardsData() {
  const res = await axios.get<CardDataMinimized[]>(
    `/card-data/processed_cards.json`,
  );
  return res.data;
}

export async function getTokensData() {
  const res = await axios.get<string[]>(`https://card.cards.army/tokens.json`);
  return res.data;
}

export const TOKEN_CARDS: CardDataMinimized[] = [
  {
    slug: "got-frog-bt-s",
    name: "Frog",
    type: "minion",
  },
  {
    slug: "pro-foot_soldier_english-d-s",
    name: "Foot Soldier",
    type: "minion",
  },
  {
    slug: "got-skeleton-bt-s",
    name: "Skeleton",
    type: "minion",
  },
  {
    slug: "art-tawny-bt-s",
    name: "Tawny",
    type: "minion",
  },
  {
    slug: "art-bruin-bt-s",
    name: "Bruin",
    type: "minion",
  },
  {
    slug: "art-lance-bt-s",
    name: "Lance",
    type: "minion",
  },
  {
    slug: "bet-rubble-bt-s",
    name: "Rubble",
    type: "site",
  },
  {
    slug: "ward",
    name: "Ward",
    type: "minion",
  },
];

export const TOKEN_RUBBLE: CardDataMinimized = {
  slug: "rubble",
  name: "Rubble",
  type: "site",
};

/**
 * FUNCTIONS FOR DRAFT
 * */

export async function getCardsFullData() {
  const res = await axios.get<CardDTO[]>(`/card-data/cards.json`);
  return res.data;
}
